export type TextSegment = { type: "text" | "url"; value: string };

// Only http(s) is matched, so a comment can never produce a javascript: link.
// The last character excludes punctuation so a link that ends a sentence does
// not swallow the period or a closing bracket.
const URL_PATTERN = /(https?:\/\/[^\s<]*[^\s<.,:;!?"')\]])/gi;

/**
 * Splits text into plain and URL segments, in order, so a caller can render the
 * URLs as links. Segments concatenate back to the original text.
 */
export function splitTextByUrls(text: string): TextSegment[] {
  return text
    .split(URL_PATTERN)
    .map((value, index) => ({
      // String.split with a single capture group yields separators at odd
      // indices, so parity identifies the matched URLs.
      type: index % 2 === 1 ? ("url" as const) : ("text" as const),
      value,
    }))
    .filter((segment) => segment.value !== "");
}
